module.exports = __webpack_public_path__ + "b072224de0b9309fd5b2436a3b9c4e17.svg";